import { Button, Grid, Typography } from "@material-ui/core";
import { useGetPessoaTaxa } from "data/api/gestao/pessoa-taxa/get-pessoa-taxa";
import { usePostPessoaTaxa } from "data/api/gestao/pessoa-taxa/post-pessoa-taxa";
import { usePutPessoaTaxa } from "data/api/gestao/pessoa-taxa/put-pessoa-taxa";
import { isEmpty } from "lodash";
import { PessoaTaxaModel } from "model/api/gestao/pessoa-taxa/pessoa-taxa-model";
import { PessoaTaxaPostModel } from "model/api/gestao/pessoa-taxa/pessoa-taxa-post-model";
import { PessoaTaxaFormModel } from "model/app/forms/pessoa-taxa/pessoa-taxa-form-model";
import { EnumTipoPessoas } from "model/enums/enum-tipo-pessoas";
import { EnumTipoTaxa } from "model/enums/enum-tipo-taxa";
import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useCadastros, useSessaoAtual, useToastSaurus } from "services/app";
import { guidEmpty } from "utils/guid-empty";
import { CircularLoading } from "views/components";
import { AccordionSaurus } from "views/components/accordions/accordion-saurus/accordion-saurus";
import { DefaultFormRefs } from "views/components/form/utils";
import { OkIcon, TermosECondicoesIcon } from "views/components/icons";
import { useThemeQueries } from "views/theme";
import { useStyles } from './accordion-cliente-taxa-styles'
import { FormPessoaTaxa } from "views/components/form/master/pessoa/pessoa-taxa/form-pessoa-taxa";
import { toDecimal } from "utils/to-decimal";
import { EnumInstituicao } from "model/enums/enum-instituicao";

interface ClienteTaxaLocationProps {
  from: {
    open: string;
  }
}

type Props = {
  id: string;
  tipoPessoa: EnumTipoPessoas;
}

export const AccordionClienteTaxa = ({ id, tipoPessoa }: Props) => {
  const { theme } = useThemeQueries()
  const [openAccordion, setOpenAccordion] = useState<boolean>(false)
  const { showToast } = useToastSaurus()
  const { state } = useLocation<ClienteTaxaLocationProps>()
  const classes = useStyles();
  const { tipoUsuario } = useSessaoAtual();
  const { abrirDialogTermosAceitos } = useCadastros()

  const { getPessoaTaxa, carregando: carregandoGet } = useGetPessoaTaxa();
  const { putPessoaTaxa, carregando: carregandoPut } = usePutPessoaTaxa();
  const { postPessoaTaxa, carregando: carregandoPost } = usePostPessoaTaxa();

  const carregando = carregandoGet || carregandoPut || carregandoPost;

  const formRef = useRef<DefaultFormRefs<PessoaTaxaFormModel>>(null);
  const scrollRef = useRef<HTMLDivElement | null>(null)

  // const isSoftwareHouse = tipoUsuario() === EnumTipoPessoas.SoftwareHouse ||
  //   tipoUsuario() === EnumTipoPessoas.FinanceiroSoftwareHouse
  const isRevenda = tipoUsuario() === EnumTipoPessoas.Revendedor ||
    tipoUsuario() === EnumTipoPessoas.FuncionarioFinanceiro;

  const permiteEdicao = (tipoPessoa === EnumTipoPessoas.Cliente && isRevenda) ||
    (tipoPessoa === EnumTipoPessoas.Revendedor && tipoUsuario() === EnumTipoPessoas.SoftwareHouse) ||
    (tipoPessoa === EnumTipoPessoas.Revendedor && tipoUsuario() === EnumTipoPessoas.Revendedor) ||
    (tipoPessoa === EnumTipoPessoas.SoftwareHouse && tipoUsuario() === EnumTipoPessoas.SoftwareHouse);

  const [response, setResponse] = useState<PessoaTaxaFormModel | null>(null);
  const search = useCallback(
    async () => {
      try {
        const res = await getPessoaTaxa(id);

        if (res.erro) throw res.erro

        let taxas = res.resultado?.data;
        if (!taxas || isEmpty(taxas)) {
          taxas = [];
        }

        const taxaVendaSoftwareHouse = taxas.find(taxa => taxa.tipoPessoa === EnumTipoPessoas.SoftwareHouse && taxa.tipoTaxa === EnumTipoTaxa.VENDA);
        const taxaVendaRevenda = taxas.find(taxa => taxa.tipoPessoa === EnumTipoPessoas.Revendedor && taxa.tipoTaxa === EnumTipoTaxa.VENDA);
        const taxaCustoRevenda = taxas.find(taxa => taxa.tipoPessoa === EnumTipoPessoas.Revendedor && taxa.tipoTaxa === EnumTipoTaxa.CUSTO);
        const taxaCustoCliente = taxas.find(taxa => taxa.tipoPessoa === EnumTipoPessoas.Cliente && taxa.tipoTaxa === EnumTipoTaxa.CUSTO);

        const resp = new PessoaTaxaFormModel(
          taxaVendaSoftwareHouse,
          taxaCustoRevenda,
          taxaVendaRevenda,
          taxaCustoCliente,
          taxaCustoCliente?.credencialId ?? taxaVendaRevenda?.credencialId ?? taxaCustoRevenda?.credencialId ?? taxaVendaSoftwareHouse?.credencialId ?? guidEmpty(),
          taxaVendaSoftwareHouse?.tipoTransacao ?? taxaCustoRevenda?.tipoTransacao ?? taxaVendaRevenda?.tipoTransacao ?? taxaCustoCliente?.tipoTransacao ?? 2,
          taxaVendaSoftwareHouse?.instituicaoFinanceira ?? taxaCustoRevenda?.instituicaoFinanceira ?? taxaVendaRevenda?.instituicaoFinanceira ?? taxaCustoCliente?.instituicaoFinanceira ?? EnumInstituicao.Safra,
        );
        formRef.current?.fillForm({ ...resp });

        setResponse(resp);

      } catch (e: any) {
        showToast("error", e.message);
      }
    },
    [getPessoaTaxa, id, showToast]
  );
  const formatarParaSalvar = useCallback((model: PessoaTaxaModel) => {
    model.valorMaximo = 5000;
    model.valorMinimo = 0;
    if (isEmpty(model.credencialId)) {
      model.credencialId = response?.credencialId || guidEmpty();
    }
  }, [response?.credencialId]);

  const saveNovaTaxa = async (model: PessoaTaxaModel) => {
    formatarParaSalvar(model);
    if (isEmpty(model.credencialId)) {
      model.credencialId = response?.credencialId || guidEmpty();
    }
    const res = await postPessoaTaxa(id, new PessoaTaxaPostModel(model.id, model.credencialId,
      id, model.tipoTransacao, model.instituicaoFinanceira,
      model.tipoTaxa, toDecimal(model.percentual), model.valorMinimo,
      model.valorMaximo));

    if (res.erro) throw res.erro
  }

  const updateTaxa = async (model: PessoaTaxaModel) => {
    formatarParaSalvar(model);
    const res = await putPessoaTaxa(id,
      new PessoaTaxaPostModel(model.id, model.credencialId,
        id, model.tipoTransacao, model.instituicaoFinanceira,
        model.tipoTaxa, toDecimal(model.percentual), model.valorMinimo,
        model.valorMaximo));

    if (res.erro) throw res.erro
  }

  const handleSubmit = async (model: PessoaTaxaFormModel) => {
    try {
      let alterou = false;
      if (tipoPessoa === EnumTipoPessoas.Cliente) {
        if ((Number(model.taxaCustoCliente?.percentual) !== response?.taxaCustoCliente?.percentual) ||
          (isEmpty(model.taxaCustoCliente?.id) && (model.taxaCustoCliente?.percentual || 0) > 0)
        ) {
          if (model.taxaCustoCliente?.id && model.taxaCustoCliente?.id !== guidEmpty()) {
            await updateTaxa(model.taxaCustoCliente!);
          } else {
            await saveNovaTaxa(model.taxaCustoCliente!);
          }
          alterou = true;
        }
      }
      if (Number(model.taxaCustoRevenda?.percentual) !== response?.taxaCustoRevenda?.percentual) {
        if (model.taxaCustoRevenda?.id) {
          await updateTaxa(model.taxaCustoRevenda!);
        } else {
          await saveNovaTaxa(model.taxaCustoRevenda!);
        }
        alterou = true;
      }

      if (Number(model.taxaVendaRevenda?.percentual) !== response?.taxaVendaRevenda?.percentual) {
        if (model.taxaVendaRevenda?.id) {
          await updateTaxa(model.taxaVendaRevenda!);
        } else {
          model.taxaVendaRevenda!.tipoTaxa = 1
          await saveNovaTaxa(model.taxaVendaRevenda!);
        }
        alterou = true;
      }

      if (tipoUsuario() === EnumTipoPessoas.SoftwareHouse) {
        if (Number(model.taxaVendaSoftwareHouse?.percentual) !== response?.taxaVendaSoftwareHouse?.percentual) {
          if (model.taxaVendaSoftwareHouse?.id) {
            await updateTaxa(model.taxaVendaSoftwareHouse!);
          } else {
            await saveNovaTaxa(model.taxaVendaSoftwareHouse!);
          }
          alterou = true;
        }
      }

      if (alterou)
        showToast('success', 'Taxas atualizadas com Sucesso.' +
          (tipoPessoa === EnumTipoPessoas.Cliente ? ' O Aceite foi enviado ao Cliente (Sistema).' : ''));
      else
        showToast('info', 'Nenhuma informação alterada.');

    }
    catch (err: any) {
      showToast('error', err.message)
    } finally {
      search();
    }
  }


  useEffect(() => {
    if (openAccordion) {
      search()
    }
  }, [openAccordion, search])

  useEffect(() => {
    if (state && state.from.open && state.from.open === 'accordionTaxa') {
      setOpenAccordion(true)
      setTimeout(() => {
        scrollRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        })
      }, 700)
    }
  }, [state])


  return (
    <>
      <AccordionSaurus
        labelPrimary="Conexão Varejo"
        tipoExpand="bold"
        noPaperRoot={false}
        heightDivider={2}
        showDivider={openAccordion}
        colorDivider={theme.palette.primary.main}
        colorExpand={theme.palette.primary.main}
        expanded={openAccordion}
        onChange={() => setOpenAccordion(prev => !prev)}
      >
        {carregando && <CircularLoading tipo='FULLSIZED' />}
        <div ref={scrollRef} className={classes.container}>
          <>
            <Typography variant="h6" className={classes.weightBold}>Pix S2Pay - Negociação</Typography>
            <FormPessoaTaxa
              loading={carregando}
              showLoading={false}
              onSubmit={handleSubmit}
              ref={formRef}
              tipoPessoa={tipoPessoa}
              pessoaId={id}
            />

            <Grid container spacing={2} justifyContent='space-between' style={{ flexDirection: 'row' }}>
              <Grid item xs={12} md={6}>
                {tipoUsuario() === EnumTipoPessoas.Revendedor && (
                  <Button fullWidth variant='outlined' color="primary" size="large" onClick={abrirDialogTermosAceitos}>
                    <TermosECondicoesIcon tipo="BUTTON" />
                    Visualizar Contrato de Parceria
                  </Button>
                )}
              </Grid>
              {permiteEdicao && (
                <Grid item xs={12} md={6}>
                  <Button fullWidth variant='contained' color='primary' size="large" onClick={() => formRef.current?.submitForm()}>
                    <OkIcon tipo='BUTTON_PRIMARY' />
                    {tipoPessoa === EnumTipoPessoas.Cliente ? 'Salvar e Enviar Aceite' : 'Salvar Taxas'}
                  </Button>
                </Grid>
              )}
            </Grid>
          </>
        </div>
      </AccordionSaurus>
    </>
  );
};